import type { DefaultLayoutTranslations } from 'vidstack'

export const translations: DefaultLayoutTranslations = {
    Announcements: 'Ankündigungen',
    Accessibility: 'Barrierefreiheit',
    AirPlay: 'AirPlay',
    Audio: 'Audio',
    Auto: 'Automatisch',
    Boost: 'Verstärken',
    Captions: 'Untertitel',
    'Caption Styles': 'Untertitel-Stile',
    'Captions look like this': 'Untertitel sehen so aus',
    Chapters: 'Kapitel',
    'Closed-Captions Off': 'Untertitel aus',
    'Closed-Captions On': 'Untertitel ein',
    Connected: 'Verbunden',
    Continue: 'Fortsetzen',
    Connecting: 'Verbinde',
    Default: 'Standard',
    Disabled: 'Deaktiviert',
    Disconnected: 'Getrennt',
    'Display Background': 'Hintergrund anzeigen',
    Download: 'Herunterladen',
    'Enter Fullscreen': 'Vollbild aktivieren',
    'Enter PiP': 'Bild-im-Bild aktivieren',
    'Exit Fullscreen': 'Vollbild beenden',
    'Exit PiP': 'Bild-im-Bild beenden',
    Font: 'Schriftart',
    Family: 'Familie',
    Fullscreen: 'Vollbild',
    'Google Cast': 'Google Cast',
    'Keyboard Animations': 'Tastatur-Animationen',
    LIVE: 'LIVE',
    Loop: 'Wiederholen',
    Mute: 'Stumm',
    Normal: 'Normal',
    Off: 'Aus',
    Pause: 'Pause',
    Play: 'Abspielen',
    Playback: 'Wiedergabe',
    PiP: 'Bild-im-Bild',
    Quality: 'Qualität',
    Replay: 'Erneut abspielen',
    Reset: 'Zurücksetzen',
    'Seek Backward': 'Zurückspulen',
    'Seek Forward': 'Vorspulen',
    Seek: 'Spulen',
    Settings: 'Einstellungen',
    'Skip To Live': 'Zu Live springen',
    Speed: 'Geschwindigkeit',
    Size: 'Größe',
    Color: 'Farbe',
    Opacity: 'Transparenz',
    Shadow: 'Schatten',
    Text: 'Text',
    'Text Background': 'Text-Hintergrund',
    Track: 'Spur',
    Unmute: 'Ton ein',
    Volume: 'Lautstärke',
}
